/** Numeric status of an SMS message as returned by the sms_manager API. */
export var SmsStatusCode = /*#__PURE__*/function (SmsStatusCode) {
  SmsStatusCode[SmsStatusCode["QUEUED"] = 0] = "QUEUED";
  SmsStatusCode[SmsStatusCode["SENT"] = 1] = "SENT";
  SmsStatusCode[SmsStatusCode["LINK_OPENED"] = 3] = "LINK_OPENED";
  SmsStatusCode[SmsStatusCode["VERIFIED"] = 4] = "VERIFIED";
  SmsStatusCode[SmsStatusCode["VIEWED"] = 5] = "VIEWED";
  SmsStatusCode[SmsStatusCode["FAILED"] = -1] = "FAILED";
  SmsStatusCode[SmsStatusCode["OPTED_OUT"] = -2] = "OPTED_OUT";
  SmsStatusCode[SmsStatusCode["EXPIRED"] = -3] = "EXPIRED";
  SmsStatusCode[SmsStatusCode["VERIFY_LOCKED"] = -4] = "VERIFY_LOCKED";
  return SmsStatusCode;
}({});

/** Reason codes returned when a send is rejected or a message fails. */

/** A single outbound SMS with its delivery/verification status. */

/** A workspace SMS template; sendable when active and containing @shortlink. */

/** Request body to create or update an SMS template. */

/** Generic paginated list envelope used by the SMS list endpoints. */

/** Request body for enqueuing an SMS to a patient. */

/** 202 response returned by the send and retry endpoints. */

/** Live `sms_status` event pushed over the worklist WebSocket. */